/**
 * url模块
 */
function _t() {
  return new RegExp(/(.*?)\.?([^\.]*?)\.?(com|net|org|biz|ws|in|me|co\.uk|co|org\.uk|ltd\.uk|plc\.uk|me\.uk|edu|mil|br\.com|cn\.com|eu\.com|hu\.com|no\.com|qc\.com|sa\.com|se\.com|se\.net|us\.com|uy\.com|ac|co\.ac|gv\.ac|or\.ac|ac\.ac|af|am|as|at|ac\.at|co\.at|gv\.at|or\.at|asn\.au|com\.au|edu\.au|org\.au|net\.au|id\.au|be|ac\.be|adm\.br|adv\.br|am\.br|arq\.br|art\.br|bio\.br|cng\.br|cnt\.br|com\.br|ecn\.br|eng\.br|esp\.br|etc\.br|eti\.br|fm\.br|fot\.br|fst\.br|g12\.br|gov\.br|ind\.br|inf\.br|jor\.br|lel\.br|med\.br|mil\.br|net\.br|nom\.br|ntr\.br|odo\.br|org\.br|ppg\.br|pro\.br|psc\.br|psi\.br|rec\.br|slg\.br|tmp\.br|tur\.br|tv\.br|vet\.br|zlg\.br|br|ab\.ca|bc\.ca|mb\.ca|nb\.ca|nf\.ca|ns\.ca|nt\.ca|on\.ca|pe\.ca|qc\.ca|sk\.ca|yk\.ca|ca|cc|ac\.cn|com\.cn|edu\.cn|gov\.cn|org\.cn|bj\.cn|sh\.cn|tj\.cn|cq\.cn|he\.cn|nm\.cn|ln\.cn|jl\.cn|hl\.cn|js\.cn|zj\.cn|ah\.cn|gd\.cn|gx\.cn|hi\.cn|sc\.cn|gz\.cn|yn\.cn|xz\.cn|sn\.cn|gs\.cn|qh\.cn|nx\.cn|xj\.cn|tw\.cn|hk\.cn|mo\.cn|cn|cx|cz|de|dk|fo|com\.ec|tm\.fr|com\.fr|asso\.fr|presse\.fr|fr|gf|gs|co\.il|net\.il|ac\.il|k12\.il|gov\.il|muni\.il|ac\.in|co\.in|org\.in|ernet\.in|gov\.in|net\.in|res\.in|is|it|ac\.jp|co\.jp|go\.jp|or\.jp|ne\.jp|ac\.kr|co\.kr|go\.kr|ne\.kr|nm\.kr|or\.kr|li|lt|lu|asso\.mc|tm\.mc|com\.mm|org\.mm|net\.mm|edu\.mm|gov\.mm|ms|nl|no|nu|pl|ro|org\.ro|store\.ro|tm\.ro|firm\.ro|www\.ro|arts\.ro|rec\.ro|info\.ro|nom\.ro|nt\.ro|se|si|com\.sg|org\.sg|net\.sg|gov\.sg|sk|st|tf|ac\.th|co\.th|go\.th|mi\.th|net\.th|or\.th|tm|to|com\.tr|edu\.tr|gov\.tr|k12\.tr|net\.tr|org\.tr|com\.tw|org\.tw|net\.tw|ac\.uk|uk\.com|uk\.net|gb\.com|gb\.net|vg|sh|kz|ch|info|ua|gov|name|pro|ie|hk|com\.hk|org\.hk|net\.hk|edu\.hk|us|tk|cd|by|ad|lv|eu\.lv|bz|es|jp|cl|ag|mobi|eu|co\.nz|org\.nz|net\.nz|maori\.nz|iwi\.nz|io|la|md|sc|sg|vc|tw|travel|my|se|tv|pt|com\.pt|edu\.pt|asia|fi|com\.ve|net\.ve|fi|org\.ve|web\.ve|info\.ve|co\.ve|tel|im|gr|ru|net\.ru|org\.ru|hr|com\.hr|ly|xyz)$/)
}

function _d(s) {
  return decodeURIComponent(s.replace(/\+/g, ' '))
}

function _i(arg, str) {
  let tmpArg = arg
  const sptr = tmpArg.charAt(0)
  const split = str.split(sptr)

  if (sptr === tmpArg) { return split }

  tmpArg = parseInt(tmpArg.substring(1), 10)

  return split[tmpArg < 0 ? split.length + tmpArg : tmpArg - 1]
}

function _f(arg, str) {
  const sptr = arg.charAt(0)
  const split = str.split('&')
  let field = []
  const params = {}
  let tmp = []
  const arg2 = arg.substring(1)

  for (let i = 0, ii = split.length; i < ii; i++) {
    field = split[i].match(/(.*?)=(.*)/)

    // TODO: regex should be able to handle this.
    if (!field) {
      field = [split[i], split[i], '']
    }

    if (field[1].replace(/\s/g, '') !== '') {
      field[2] = _d(field[2] || '')

            // If we have a match just return it right away.
      if (arg2 === field[1]) { return field[2] }

            // Check for array pattern.
      tmp = field[1].match(/(.*)\[([0-9]+)\]/)

      if (tmp) {
        params[tmp[1]] = params[tmp[1]] || []

        params[tmp[1]][tmp[2]] = field[2]
      } else {
        params[field[1]] = field[2]
      }
    }
  }

  if (sptr === arg) { return params }

  return params[arg2]
}

const fnUrl = function(arg, url) {
  const _l = {}
  let tmp
  let tmpUrl = url
  let tmpArg = arg

  if (tmpArg === 'tld?') { return _t() }

  tmpUrl = tmpUrl || window.location.toString()

  if (!tmpArg) { return tmpUrl }

  tmpArg = tmpArg.toString()

  let matchResult = tmpUrl.match(/^mailto:([^\/].+)/)

  if (matchResult) {
    _l.protocol = 'mailto'
    _l.email = matchResult[1]
  } else {
    // Ignore Hashbangs.
    matchResult = tmpUrl.match(/(.*?)\/#\!(.*)/)
    if (matchResult) {
      tmpUrl = matchResult[1] + matchResult[2]
    }

    // Hash.
    matchResult = tmpUrl.match(/(.*?)#(.*)/)
    if (matchResult) {
      _l.hash = matchResult[2]
      tmpUrl = matchResult[1]
    }

    // Return hash parts.
    if (_l.hash && tmpArg.match(/^#/)) { return _f(tmpArg, _l.hash) }

    // Query
    matchResult = tmpUrl.match(/(.*?)\?(.*)/)
    if (matchResult) {
      _l.query = matchResult[2]
      tmpUrl = matchResult[1]
    }

    // Return query parts.
    if (_l.query && tmpArg.match(/^\?/)) { return _f(tmpArg, _l.query) }

    // Protocol.
    matchResult = tmpUrl.match(/(.*?)\:?\/\/(.*)/)
    if (matchResult) {
      _l.protocol = matchResult[1].toLowerCase()
      tmpUrl = matchResult[2]
    }

    // Path.
    matchResult = tmpUrl.match(/(.*?)(\/.*)/)
    if (matchResult) {
      _l.path = matchResult[2]
      tmpUrl = matchResult[1]
    }

    // Clean up path.
    _l.path = (_l.path || '').replace(/^([^\/])/, '/$1').replace(/\/$/, '')

    // Return path parts.
    if (tmpArg.match(/^[\-0-9]+$/)) { tmpArg = tmpArg.replace(/^([^\/])/, '/$1') }
    if (tmpArg.match(/^\//)) { return _i(tmpArg, _l.path.substring(1)) }

    // File.
    tmp = _i('/-1', _l.path.substring(1))

    matchResult = tmp.match(/(.*?)\.(.*)/)
    if (tmp && matchResult) {
      _l.file = matchResult[0]
      _l.filename = matchResult[1]
      _l.fileext = matchResult[2]
    }

    // Port.
    matchResult = tmpUrl.match(/(.*)\:([0-9]+)$/)
    if (matchResult) {
      _l.port = matchResult[2]
      tmpUrl = matchResult[1]
    }

    // Auth.
    matchResult = tmpUrl.match(/(.*?)@(.*)/)
    if (matchResult) {
      _l.auth = matchResult[1]
      tmpUrl = matchResult[2]
    }

        // User and pass.
    if (_l.auth) {
      tmp = _l.auth.match(/(.*)\:(.*)/)

      _l.user = tmp ? tmp[1] : _l.auth
      _l.pass = tmp ? tmp[2] : undefined
    }

        // Hostname.
    _l.hostname = tmpUrl.toLowerCase()

        // Return hostname parts.
    if (tmpArg.charAt(0) === '.') { return _i(tmpArg, _l.hostname) }

        // Domain, tld and sub domain.
    if (_t()) {
      tmp = _l.hostname.match(_t())

      if (tmp) {
        _l.tld = tmp[3]
        _l.domain = tmp[2] ? tmp[2] + '.' + tmp[3] : undefined
        _l.sub = tmp[1] || undefined
      }
    }

        // Set port and protocol defaults if not set.
    _l.port = _l.port || (_l.protocol === 'https' ? '443' : '80')
    _l.protocol = _l.protocol || (_l.port === '443' ? 'https' : 'http')
  }

    // Return arg.
  if (tmpArg in _l) { return _l[tmpArg] }

    // Return everything.
  if (tmpArg === '{}') { return _l }

  // Default to undefined for no match.
  return undefined
}

export default fnUrl
